import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Avatar from '@material-ui/core/Avatar';

import SpeakerBioModal from './SpeakerBioModal';

const RootContainer = styled.div`
  flex: 1 0 auto;
  display: flex;
  min-width: 250px;
  align-items: center;
  margin-right: 40px;
  padding: 16px 0 0;
  cursor: pointer;
  overflow: hidden;
`;

const ProfileContainer = styled.div`
  margin-left: 16px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 58px;
  overflow: hidden;
  flex: 1 1 auto;
  width: 0;
`;

const NameContainer = styled.div`
  white-space: nowrap;
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 18px;
  color: #484848;
  text-overflow: ellipsis;
  overflow: hidden;
`;

const CompanyTitleContainer = styled.div`
  white-space: nowrap;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
  color: rgba(0, 0, 0, 0.5);
  text-overflow: ellipsis;
  overflow: hidden;
`;

const StyledAvatar = styled(Avatar)`
  width: 48px;
  height: 48px;
`;

const SpeakerItem = ({
  name, company, title, avatar, bio,
}) => {
  const [openBio, setOpenBio] = useState(false);

  const onBioOpen = () => {
    setOpenBio(true);
  };

  const onBioClose = () => {
    setOpenBio(false);
  };

  return (
    <>
      <RootContainer onClick={onBioOpen}>
        <StyledAvatar alt={name} src={avatar} />
        <ProfileContainer>
          {name && <NameContainer>{ name }</NameContainer>}
          {company && <CompanyTitleContainer>{ company }</CompanyTitleContainer>}
          {title && <CompanyTitleContainer>{ title }</CompanyTitleContainer>}
        </ProfileContainer>
      </RootContainer>
      <SpeakerBioModal
        open={openBio}
        onClose={onBioClose}
        name={name}
        company={company}
        title={title}
        avatar={avatar}
        bio={bio}
      />
    </>
  );
};

SpeakerItem.propTypes = {
  name: PropTypes.string,
  company: PropTypes.string,
  title: PropTypes.string,
  avatar: PropTypes.string,
  bio: PropTypes.string,
};

SpeakerItem.defaultProps = {
  name: '',
  company: '',
  title: '',
  avatar: '',
  bio: '',
};

export default SpeakerItem;
